// extracted by mini-css-extract-plugin
export var blockquote = "Wysiwyg-module--blockquote--232ee";
export var blockquoteIcon = "Wysiwyg-module--blockquote-icon--100ed";
export var pageContent = "Wysiwyg-module--page-content--4e4ab";
export var plainList = "Wysiwyg-module--plain-list--6092b";
export var wysiwyg = "Wysiwyg-module--wysiwyg--cb696";